import React, { useState } from 'react';

const ID = 'checkbox-input';
export interface CheckboxInputProps {
    id?: string;
    onChange?: (value: boolean) => void;
    onFocusChange?: () => void;
    value?: boolean;
    label?: React.ReactNode;
    autoFocus?: boolean;
    disabled?: boolean;
    submitted?: boolean;
    useConditionedStyling?: boolean;
    className?: string;
}

export const CheckboxInput = (props: CheckboxInputProps) => {
    const [internalValue, setInternalValue] = useState<boolean>(props.value || false);

    const isControlled = props.value !== undefined;
    const currentValue = isControlled ? props.value : internalValue;

    const handleChange = () => {
        if (!props.disabled) {
            const newValue = !currentValue;
            if (!isControlled) {
                setInternalValue(newValue);
            }
            props.onChange && props.onChange(newValue);
        }
    };

    return (
        <div className='inline-flex content-center items-start justify-start gap-2'>
            <label
                htmlFor={props.id + ID}
                aria-disabled={props.disabled}
                className='relative !m-0 flex cursor-pointer items-center has-[>_:disabled]:cursor-not-allowed'>
                <input
                    id={props.id + ID}
                    type='checkbox'
                    checked={currentValue}
                    onChange={handleChange}
                    disabled={props.disabled}
                    autoFocus={props.autoFocus}
                    onFocus={() => {
                        props.onFocusChange && props.onFocusChange();
                    }}
                    className='peer bg-always-white hover:bg-brand-primary/50 border-border-default checked:border-brand-primary checked:bg-brand-primary h-5 w-5 cursor-pointer appearance-none rounded border shadow transition-all hover:shadow-md disabled:cursor-not-allowed disabled:shadow-none disabled:bg-background-default'
                />
                <span className='text-always-white pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform opacity-0 peer-checked:opacity-100'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-3.5 w-3.5'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                        stroke='currentColor'
                        strokeWidth='1'>
                        <path
                            fillRule='evenodd'
                            d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                            clipRule='evenodd'></path>
                    </svg>
                </span>
            </label>
            {props.label && (
                <label
                    htmlFor={props.id + ID}
                    className='text-foreground-default justify-start text-base font-medium'>
                    {props.label}
                </label>
            )}
        </div>
    );
};
